<template>
    <p-search-screen
        title="Return Adjustment Reasons"
        api-destination="returnadjustmentreason"
        edit-key="returnAdjustmentReasonId"
        :filters="filters"
        :fields="fields"
        :filterBy="filterBy"
        :show-set-to="false"
        :use-is-active-checkbox="false"
        add-new-button>   
        <template v-slot:cell(glCode)="{  }">
            <span>Unassigned</span>
        </template>
    </p-search-screen>
</template>
<script>
    import SearchStorage from '@/components/mixins/SearchFilterStorage.js';
    export default {
        mixins: [SearchStorage],
        data() {
            return {
                isBusy: false,
                filterName: 'ReturnAdjustmentReasonFilter',
                filters: {
                    automatic: '',
                    perPage: 100,
                    sortBy: 'reason',
                    sortDesc: true,                
                    searchBy: 'All'
                },
                filterBy: ['All', 'Adjustment Reason', 'Reason Description', 'GL Code'],
                fields: [
                    {
                        key: 'reason',
                        sortable: true,
                        label: 'Adjustment Reason'
                    },
                    {
                        key: 'description',
                        sortable: true,
                        label: 'Reason Description'
                    },
                    {
                        key: 'ledgerNumbers',
                        sortable: true,
                        label: 'GL Code'
                    },
                    {
                        key: 'isActive',
                        label: 'Status',
                        formatter: value => {
                            return value ? 'Active' : 'Inactive';
                        },
                        sortable: true
                    }
                ]
            };
        },
        methods: {}
    };
</script>